import { render, staticRenderFns } from "./CompRestrictedV2.vue?vue&type=template&id=5f9c9c61&scoped=true&"
import script from "./CompRestrictedV2.vue?vue&type=script&lang=ts&"
export * from "./CompRestrictedV2.vue?vue&type=script&lang=ts&"
import style0 from "./CompRestrictedV2.vue?vue&type=style&index=0&id=5f9c9c61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9c9c61",
  null
  
)

export default component.exports